import { AutocompleteRenderGetTagProps, Chip } from '@mui/material';
import AppSelect from 'components/AppSelect';
import type { YandexTrackerQueue } from 'model/yandex-tracker';

interface QueuesSelectProps {
  value: string[];
  onChange: (queueIds: string[]) => void;
  options: YandexTrackerQueue[];
  error?: boolean;
  helperText?: string;
}

function QueuesSelect({
  value,
  onChange,
  options,
  error,
  helperText,
}: QueuesSelectProps): React.ReactElement {
  const selectedQueues = options.filter((q) => value.includes(q.id));

  const handleChange = (_: React.SyntheticEvent, newValue: YandexTrackerQueue[]) => {
    onChange((newValue ?? []).map((q) => q.id));
  };

  const renderTags = (tags: YandexTrackerQueue[], getTagProps: AutocompleteRenderGetTagProps) =>
    tags.map((queue, index) => (
      <Chip {...getTagProps({ index })} key={queue.id} label={queue.name} size="small" />
    ));

  return (
    <AppSelect<YandexTrackerQueue, true>
      multiple
      options={options}
      getOptionLabel={(option) => option.name}
      value={selectedQueues}
      onChange={handleChange}
      renderTags={renderTags}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      label="Очереди Яндекс Трекера"
      textFieldProps={{ error, helperText }}
      sx={{ mt: 2 }}
    />
  );
}

export default QueuesSelect;
